var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-header",class:("header-" + _vm.theme)},[_c('h4',[_c('i',{staticClass:"fa fa-pencil-square"}),_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }